import PropTypes from 'prop-types';
import React from 'react';
import { Card, Col, Row, Table } from 'react-bootstrap';

const InformacionGlobal = ({ informacionGlobal }) => {
    if (!informacionGlobal || !informacionGlobal.existe) return null;

    const periodicidadMap = {
        '01': '01 Diario',
        '02': '02 Semanal',
        '03': '03 Quincenal',
        '04': '04 Mensual',
        '05': '05 Bimestral',
        '06': '06 Trimestral',
        '07': '07 Cuatrimestral',
        '08': '08 Semestral',
        '09': '09 Anual'
    };

    const mesesMap = {
        '01': '01 Enero',
        '02': '02 Febrero',
        '03': '03 Marzo',
        '04': '04 Abril',
        '05': '05 Mayo',
        '06': '06 Junio',
        '07': '07 Julio',
        '08': '08 Agosto',
        '09': '09 Septiembre',
        '10': '10 Octubre',
        '11': '11 Noviembre',
        '12': '12 Diciembre'
    };

    return (
        <Row className="mb-3">
            <Col md={12}>
                <Card className="shadow-sm border">
                    <Card.Body className="p-0">
                        <Table borderless className="mb-0 small" style={{ tableLayout: "fixed", width: "100%" }}>
                            <tbody>
                                <tr className="bg-light">
                                    <td className="text-dark fw-bold px-3 py-2" style={{ fontSize: "0.9rem", borderBottom: "1px solid #dee2e6", width: "200px" }}>
                                        Informaci n Global
                                    </td>
                                    <td className="px-3 py-2" style={{ fontSize: "0.9rem", borderBottom: "1px solid #dee2e6" }}></td>
                                </tr>
                                <tr className="bg-light">
                                    <td colSpan="2" className="text-dark px-3 py-2" style={{ fontSize: "0.85rem", borderBottom: "1px solid #dee2e6" }}>
                                        <div className="d-flex align-items-center">
                                            <span className="fw-bold">Periodicidad:</span>
                                            <span className="ms-2 me-4">
                                                {periodicidadMap[informacionGlobal.periodicidad] || informacionGlobal.periodicidad}
                                            </span>
                                            <span className="fw-bold">Meses:</span>
                                            <span className="ms-2 me-4">
                                                {mesesMap[informacionGlobal.mes] || informacionGlobal.mes}
                                            </span>
                                            <span className="fw-bold">A o:</span>
                                            <span className="ms-2">{informacionGlobal.anio}</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

InformacionGlobal.propTypes = {
    informacionGlobal: PropTypes.object
};

export default InformacionGlobal;